import React, { Component } from "react";
import ValidBrowser from "../Utils/ValidBrowser";
import { testValidBrowser } from "../Utils/helpers";
import Firebase, { METHODS } from "../Utils/Firebase";
import { snapShotToArray } from "../Utils/helpers";
import NavButton from "../Components/Button/Nav.button.jsx";
import Pagination from "../Components/Pagination.jsx";
import LoaderModule from "../Components/Loader.jsx";
import DisabledRecordButton from "../Components/Button/DisabledRecordButton";

const style = {
  social: {
    position: "absolute",
    right: "50px",
    marginTop: "13px",
    marginLeft: "20px"
  },
  noSpeech: {
    marginTop: "-50px"
  },
  info: {
    color: "red",
    display: "bloc",
    fontSize: ".7rem"
  },
  link: {
    color: "blue",
    textDecoration: "underline"
  },
  MySpeeches: {
    padding: "10px 0",
    margin: "0",
    h2: {
      fontSize: "2em",
      textTransform: "uppercase",
      textAlign: "left",
      paddingLeft: "20px"
    }
  },
  EvaluableSpeeches: {
    backgroundColor: "rgba(50,0,20,0.1)",
    padding: "10px 0"
  }
};

export default class SpeechesPage extends Component {
  render() {
    const { user } = this.props;
    const userUid = user.uid;
    let myVideos = [];
    let othersVideos = [];

    return (
      <div style={{marginTop: "100px"}}>
        <Firebase
          refPath="/videos"
          method={METHODS.ON}
          renderSuccess={(snapshot) => {
            if (!snapshot.val()) {
              myVideos = [];
              othersVideos = [];
            }
            else {
              const videos = snapShotToArray(snapshot);
              myVideos = videos.filter((video) => video.userId === userUid);
              othersVideos = videos.filter(
                (video) => video.userId !== userUid
              );
            }

            return (
              <div className="Speeches">
                <div style={style.MySpeeches}>
                  <h2 style={style.MySpeeches.h2}>
                    Mes pitchs
                  </h2>

                  {
                    myVideos.length > 0 ? (
                      // Set pageLimit to "0" hide the pagination
                      <Pagination
                        videos={myVideos.reverse()}
                        pageLimit={myVideos.length > 10 ? 1 : 0}
                        videoLimit={10}
                        isVideoCardShareable
                        isEvaluationCheckable
                        currentUser={userUid}
                      />
                    ) : (
                      <div style={style.noSpeech}>
                        <p>Pas encore de pitch à ton actif ...</p>

                        <ValidBrowser
                          test={testValidBrowser}
                          valid={
                            <NavButton
                              label="Enregistrer"
                              href="/record"
                              disabled={false}
                            />
                          }
                          error={
                            <DisabledRecordButton />
                          }
                        />
                      </div>
                    )
                  }
                </div>

                <div style={style.EvaluableSpeeches}>
                  <h2 style={style.MySpeeches.h2}>
                    Pitchs à évaluer
                  </h2>
                    {
                      othersVideos.length > 0 ? (
                        <Pagination
                          videos={othersVideos.reverse()}
                          pageLimit={othersVideos.length > 10 ? 1 : 0}
                          videoLimit={10}
                          isSpeechEvaluable
                          currentUser={userUid}
                        />
                      ) : (
                        <div style={style.noSpeech}>
                          <p>Pas encore de pitch ...</p>
                        </div>
                      )
                    }
                </div>
              </div>
            );
          }}
          renderError={(error) => {
            return <pre>{JSON.stringify(error)}</pre>;
          }}
          renderPending={() => <LoaderModule />}
        />
      </div>
    );
  }
}
